import React from 'react'
import FooterTop from './FooterTop'
import FooterBottom from './FooterBottom'
import { Link } from 'react-router-dom';

import '../css/footermain.css'

function Footer() {
  return (
    
    <div>

       <div className='social-link-home'>
      <div className='inst-box'>
        <Link to="https://www.instagram.com/sanskarjaipur">
        <img src="../img/social-link/inst.png" alt="sanskar instagram" />
        </Link>
      </div>
      <div className='inst-box'>
        <Link to="https://www.facebook.com/sanskarschooljpr">
        <img src="../img/social-link/fb.png" alt="sanskar facebook" />
        </Link>
      </div>
    </div>
    {/* <FooterTop/> */}
    <div className='footer-bottom-main'>
    <FooterBottom/>
    </div>
    </div>
  )
}

export default Footer
